// src/core/theme/breakpoints.ts

import { BreakpointsOptions } from "@mui/material/styles";

const customBreakpoints: BreakpointsOptions = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1200,
    xl: 1536,
  },
};

export default customBreakpoints;
